
import React from 'react';
import { Link } from 'react-router-dom';

const Testimonial: React.FC<{ quote: string; author: string; role: string; id: string }> = ({ quote, author, role, id }) => (
  <div className="p-12 rounded-[3rem] glass-card border-white/5 space-y-10 relative overflow-hidden group hover:border-[#32dee6]/30 transition-all flex flex-col justify-between h-full">
    <div className="space-y-10">
      <div className="absolute top-8 left-8 mono text-[9px] text-white/10 font-bold uppercase tracking-[0.4em]">LOG_ENTRY_{id}</div>
      <p className="text-2xl text-gray-300 font-light leading-relaxed italic">"{quote}"</p>
    </div>
    <div className="pt-8 border-t border-white/5 flex items-end justify-between">
      <div>
        <h5 className="font-bold text-white text-lg tracking-tight">{author}</h5>
        <p className="mono text-[10px] text-[#32dee6] font-bold uppercase tracking-widest mt-1">{role}</p>
      </div>
      <Link 
        to="/contact" 
        className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center group-hover:bg-[#32dee6] group-hover:text-black transition-all"
        title="View Case Logistics"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 7 17 17"></polyline></svg>
      </Link>
    </div>
  </div>
);

const Testimonials: React.FC = () => {
  return (
    <section id="testimonials" className="py-40 px-6 bg-[#050505]">
      <div className="container mx-auto">
        <div className="mb-24 space-y-4 text-right">
          <div className="mono text-[10px] font-bold text-[#32dee6] tracking-[0.4em] uppercase">Success_Metrics</div>
          <h2 className="text-6xl md:text-8xl font-extrabold text-white tracking-tighter">HISTORY.</h2>
          <p className="text-xl text-gray-500 font-light ml-auto max-w-2xl">Proven reliability across diverse business environments, from legal groups to medical practices.</p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          <Testimonial 
            id="001"
            quote="The infrastructure deployment was seamless. Within two weeks, our voice system was handling 100% of incoming inquiries without a human operator."
            author="Mark Richardson"
            role="System Admin // Legal Services"
          />
          <Testimonial 
            id="002"
            quote="FrontDesk recovered 40% of dormant leads via the reactivation node. It's essentially free revenue generated by the system autonomously."
            author="Sarah Chen"
            role="Operations Lead // Real Estate"
          />
          <Testimonial 
            id="003"
            quote="The speed-to-lead latency is practically zero. It bridges the gap between inquiry and scheduling faster than any human team possibly could."
            author="Dr. James Miller"
            role="Director // Medical Practice"
          />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
